// export const BaseBackEndURL = "http://rkrds-staging.eu-west-3.elasticbeanstalk.com/";
// export const BaseBackEndURL = "http://localhost:8000/";
// export const BaseBackEndURL = "http://127.0.0.1:8000/";
// export const BaseBackEndURL = "http://localhost:8001/";
// export const BaseBackEndURL = "http://localhost:8002/";
// export const BaseBackEndURL = "http://localhost:8003/";
// export const BaseBackEndURL = "http://localhost:8004/";
// export const BaseBackEndURL = "http://localhost/";

export const BaseBackEndURL = process.env.REACT_APP_BaseBackEndURL;
export const BaseLoginURL = BaseBackEndURL + "rekords/login";


// export const BaseExportDataURL = "/export/csv/";

export const BaseEntityURL = "entities/";
export const BaseCheckAndGetEntityPkURL = `${BaseEntityURL}check-and-get-entity/`;

export const BaseImportDataURL = "import-data/";
export const BaseViewClassAttendanceURL = BaseImportDataURL + "view-class-attendance/";
export const BaseFixClassAttendanceWithoutAttendanceURL = BaseImportDataURL + "fix-class-attendance-without-entity/";
export const BaseFixNoneCreatedByModifiedByURL = BaseImportDataURL + "fix_none_created_by_modified_by/";
export const BaseViewNoneCreatedByModifiedByEntityURL = BaseImportDataURL + "view_none_created_by_modified_by_entity/";
export const BaseFixClassesGenderURL = BaseImportDataURL + "fix_classes_gender/";
export const BaseFixClassAndRecurringWithoutTrainingAreaURL = BaseImportDataURL + "fix-class-and-recurring-without-training-area/";
export const BaseFixClassAndRecurringForClientsURL = BaseImportDataURL + "fix-class-and_recurring-for-clients/";



export const BaseUserURL = "users/";
export const BaseMyProfileURL = BaseUserURL + "my-profile/";

export const BasePermissionsURL = BaseBackEndURL + "users/permissions/";


